<div class="font-normal text-[0.8125rem] leading-[1.125rem] text-font-secondary mb-2">
  {{ label }}
</div>

<div class="font-semibold text-[0.9375rem] leading-[1.3125rem]">
  <ng-content>
    <div [class]="!value ? 'text-font-muted font-normal' : 'break-anywhere'" [title]="value | notAvailable">{{ value | notAvailable }}</div>
  </ng-content>
</div>
